<template>
  <header class="tw-bg-white/80 tw-backdrop-blur-md tw-sticky tw-top-0 tw-z-50 tw-border-b tw-border-gray-100">
    <nav class="tw-container tw-mx-auto tw-px-6 tw-py-4">
      <div class="tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-items-center">
          <img
            src="/images/logo.png"
            alt="TopEshows logo"
            class="tw-h-16 tw-w-auto tw-object-contain"
            loading="lazy"
          >
        </div>
        <div class="tw-hidden md:tw-flex tw-space-x-10">
          <RouterLink
            :to="{ name: 'home', hash: '#how-it-works' }"
            class="tw-text-gray-600 hover:tw-text-primary-600 tw-transition-colors tw-text-sm tw-font-medium"
          >
            How It Works
          </RouterLink>
          <RouterLink
            :to="{ name: 'home', hash: '#case-studies' }"
            class="tw-text-gray-600 hover:tw-text-primary-600 tw-transition-colors tw-text-sm tw-font-medium"
          >
            Case Studies
          </RouterLink>
          <RouterLink
            :to="{ name: 'home', hash: '#pricing' }"
            class="tw-text-gray-600 hover:tw-text-primary-600 tw-transition-colors tw-text-sm tw-font-medium"
          >
            Pricing
          </RouterLink>
        </div>
        <a
          :href="appConfig.calendlyUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="tw-bg-primary-600 tw-text-white tw-px-6 tw-py-2.5 tw-rounded-xl hover:tw-bg-primary-700 tw-transition-all tw-font-semibold tw-text-sm tw-shadow-sm hover:tw-shadow-md tw-inline-block"
        >
          Schedule a Demo
        </a>
      </div>
    </nav>
  </header>
</template>

<script setup>
import appConfig from '../config/app.config.js';
</script>

